export const educationLevelTypes = [
  { label: "Sin Estudios", value: "NO_EDUCATION" },
  { label: "Primaria", value: "ELEMENTAL_PRIMARY" },
  { label: "Secundaria", value: "ELEMENTAL_SECONDARY" },
  { label: "Bachillerato", value: "HIGH_SCHOOL" },
  { label: "Superior", value: "HIGHER" }
]
